module.exports = __webpack_public_path__ + "static/media/fly0283.a8988151.webp";